<template>
	<GT
		:photos="photos"
		:about="about"
		:title="title"
		:trip="trip"
		:cost="cost"
		:showInquiry="true"
	></GT>
</template>
<script>
import GT from "@/components/GTnormal.vue";
export default {
	components: {
		GT,
	},
	data() {
		return {
			title: "South Boulder Creek Private Water",
			trip: "South Boulder Creek",
			about:
				"Experience the ultimate fly fishing adventure on nearly a mile of exclusive water along South Boulder Creek, just 40 minutes from our shop. Nestled at 8,500 feet with breathtaking views of the Continental Divide, this private oasis offers fantastic summer hatches and excellent dry fly opportunities for Brook, Brown, Rainbow, and Cutthroat trout. Perfect for groups of 1 to 6 anglers, our private guided tours are available in half-day and full-day options. Escape the crowds and immerse yourself in the serene beauty of a private stretch. South Boulder Creek, a hidden gem for anglers of all skill levels. Book your private fly fishing experience today!",
			photos: [
				require("../../Photos/sbcprivate/IMG_0706.jpg"),
				require("../../Photos/sbcprivate/IMG_0705.jpg"),
				require("../../Photos/sbcprivate/IMG_0703.jpg"),
				require("../../Photos/sbcprivate/image0.jpeg"),
				require("../../Photos/sbcprivate/ECFD12F1-E0CD-4B30-8343-B7DFE836218B.png"),
				require("../../Photos/sbcprivate/44F7DA39-467B-4317-BD97-15B8B39F0D7A.png"),
			],
			cost: [
				"1 Person Half Day $345",
				"2 Person Half Day $495",
				"3 Person Half Day $645",
				"* Maximum of 3 anglers/ clients per guide on all guided trips",
				"1 Person Full Day $495",
				"2 Person Full Day $695",
				"3 Person Full Day $895",
			],
		};
	},
};
</script>
